import React, { useState, useEffect, useRef } from 'react';
import { formatResultDescription } from '../helpers/gamePlayHelpers';

const REVEAL_INTERVAL_MS = 500;

const PlayByPlayReveal = ({ lines, gameSpeed = 1 }) => {
    const [visibleCount, setVisibleCount] = useState(1);
    const timerRef = useRef(null);
    const linesKeyRef = useRef(lines);

    useEffect(() => {
        if (lines !== linesKeyRef.current) {
            linesKeyRef.current = lines;
            setVisibleCount(1);
        }
    }, [lines]);

    useEffect(() => {
        if (!lines || visibleCount >= lines.length) return;
        const interval = REVEAL_INTERVAL_MS * gameSpeed;
        timerRef.current = setTimeout(() => setVisibleCount(c => c + 1), interval);
        return () => clearTimeout(timerRef.current);
    }, [visibleCount, lines, gameSpeed]);

    if (!lines?.length) return null;

    return (
        <div className="play-by-play-reveal">
            {lines.slice(0, visibleCount).map((line, i) => (
                <div key={i} className="play-by-play-line">
                    {formatResultDescription(line)}
                </div>
            ))}
        </div>
    );
};

export default PlayByPlayReveal;
